import ConditionBox from '../common/ConditionBox';
import ConditionError from '../common/ConditionError';
import EditorConditionActionsContainer from './EditorConditionActionsContainer';
import EditorConditionInputs from './EditorConditionInputs';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { LogicGroupNames } from '../../filterQueryFormat/logic/LogicGroup';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorConditionBase = ({
  children,
  condition,
  conditionPath,
  dataSeleniumInfo,
  filterFamily,
  logicOperator = LogicGroupNames.AND,
  onConditionDelete,
  onConditionOperatorChange,
  onConditionValueChange,
  isRefinement,
  isRefinementEnabled
}) => {
  return /*#__PURE__*/_jsx(EditorConditionActionsContainer, {
    condition: condition,
    conditionPath: conditionPath,
    dataSeleniumInfo: dataSeleniumInfo,
    filterFamily: filterFamily,
    onConditionDelete: onConditionDelete,
    isRefinement: isRefinement,
    children: /*#__PURE__*/_jsxs(ConditionBox, {
      logicOperator: logicOperator,
      isRefinement: isRefinement,
      children: [/*#__PURE__*/_jsx(EditorConditionInputs, {
        condition: condition,
        dataSeleniumInfo: dataSeleniumInfo,
        filterFamily: filterFamily,
        onConditionOperatorChange: onConditionOperatorChange,
        onConditionValueChange: onConditionValueChange,
        isRefinement: isRefinement,
        isRefinementEnabled: isRefinementEnabled,
        children: children
      }), /*#__PURE__*/_jsx(ConditionError, {
        condition: condition
      }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
        condition: condition
      })]
    })
  });
};
export default EditorConditionBase;